const PATH = 'fe.components.app.header';

const messages = {
  home: {
    key: `${PATH}.home`,
    defaultValue: 'Home'
  },
  help: {
    key: `${PATH}.help`,
    defaultValue: 'Help'
  },
  navMenu: {
    key: `${PATH}.nav_menu`,
    defaultValue: 'Navigation menu'
  },
  learningResources: {
    key: `${PATH}.learning_resources`,
    defaultValue: 'Learning Resources 2.0'
  },
  mainNav: {
    key: `${PATH}.main_nav`,
    defaultValue: 'Main'
  }
};

export default messages;
